(function() {
	'use strict';
	angular.module('app.core')
		.directive('leanDemandSimulationFilter', leanDemandSimulationFilter);

	leanDemandSimulationFilter.$inject = ['$filter', '$timeout', '$rootScope'];
	function leanDemandSimulationFilter($filter, $timeout, $rootScope) {
		var html = '<div class="string-menu" style="width: 50vw; min-width: 500px !important;" ng-show="$parent.filterFunctions.getViewValues().visibleMenu == ' + "'" + '{{filterId}}' + "'" + '" ng-click="$event.stopPropagation();">' +
						'<form name="stringForm" novalidate>' +
							'<div class="string-header">' +
								'<div class="string-title"><span translate> {{filterName}}</span></div>' +
							'</div>' +
							'<div class="string-body" style="margin: 0 1em; width: auto;">' +
								'<div class="row row-4-padding" style="margin: 0;">' +
									'<div class="col-md-4 forecast-column-label" translate>End item</div>' +
									'<div class="col-md-4 forecast-column-label" translate>Needed date</div>' +
									'<div class="col-md-3 forecast-column-label" translate>Quantity</div>' +
								'</div>' +
								'<div class="row row-4-padding" style="margin: 0;" ng-show="demandSimulations && demandSimulations.length" ng-repeat="demand in demandSimulations">' +
									'<div class="col-md-4 user-single-select">' +
										'<ui-select theme="bootstrap" ng-model="demand.itemNdx" name="itemNdx" search-enabled="true" ng-required="true" tabindex="{{$index * 4 + 1}}" autofocus="true">' +
										'	<ui-select-match placeholder="{{\'Enter item code...\'|translate}}">{{trimZeroes($select.selected.endItemCode)}}</ui-select-match>' +
										'		<ui-select-choices repeat="endItem.endItemNdx as endItem in filterEndItems($select.search, demand)">' +
										'			<div translate>{{trimZeroes(endItem.endItemCode)}}</div>' +
										'		</ui-select-choices>' +
										'</ui-select>' +
									'</div>' +
									'<div class="col-md-4">' +
										'<div class="input-group">' +
											'<input tabindex="{{$index * 4 + 2}}" type="text" class="form-control" ng-class="{\'ng-invalid\': demand.errorMessage && demand.errorMessage.length}" ' +
												'title="{{demand.errorMessage}}" uib-datepicker-popup="mediumDate" ng-model="demand.date" ' +
												'is-open="demand.forecastDatePickerOpen" close-text="Cancel" ' +
												'datepicker-options="{\'showWeeks\':false, \'minDate\': \'{minDate}\'}" ' +
												'ng-click="openDemandDatePicker(demand)" ng-required="true" ng-disabled="readOnly"/>' +
											'<span class="input-group-btn">' +
												'<button tabindex="{{$index * 4 + 3}}" ng-class="{\'ng-invalid\': demand.errorMessage && demand.errorMessage.length}" type="button" ' +
													'class="btn btn-default" ng-click="demand.forecastDatePickerOpen = true" ng-disabled="readOnly">' +
													'<i class="fa fa-calendar"></i>' +
												'</button>' +
											'</span>' +
										'</div>' +
									'</div>' +
									'<div class="col-md-3"><input tabindex="{{$index * 4 + 4}}" class="form-control" type="number" min="0" ng-model="demand.quantity" ng-required="true" ng-disabled="readOnly"></div>' +
									'<div class="col-md-1"><i class="fa fa-times" ng-show="demandSimulations.length > 1" style="padding-top: 9px; font-size: 15px; cursor: pointer;" ng-click="removeDemandRow($index)"></i></div>' +
								'</div>' +
							'</div>' +
							'<div class="forecast-add-line" ng-show="demandSimulations.length < 15" style="margin: 0 1em 1em; width: auto;">' +
								'<span>' +
									'<i class="fa fa-plus-circle" style="cursor: pointer;" ng-click="addDemandRow()"></i>' +
								'</span>' +
							'</div>' +
							'<div class="string-footer" ng-show="!readOnly">' +
								'<button tabindex="{{demandSimulations.length * 4 + 1}}" type="button" class="button flat colored innerButton" ng-click="$parent.filterFunctions.cancelSelection()">' +
									'<span translate>Cancel</span>' +
								'</button>' +
								'<button tabindex="{{demandSimulations.length * 4 + 2}}" type="submit" class="button flat colored innerButton" ng-disabled="$parent.filterFunctions.isReadOnly()" ng-click="applyDemandSelection($event, filterId)">' +
									'<span translate>Apply</span>' +
								'</button>' +
								'<button tabindex="{{demandSimulations.length * 4 + 3}}" type="button" class="button flat colored innerButton" ng-disabled="!hasUserInput()" ng-click="resetDemandSimulations($event)" data-tracking-id="btn__reset-demand-simulations" uib-tooltip="{{\'Clear all simulations\' | translate}}" tooltip-placement="top">' +
									'<i class="fa fa-eraser" style="margin-right: 4px;"></i><span translate>Reset</span>' +
								'</button>' +
							'</div>' +
						'</form>' +
					'</div>';
		return {
			restrict:'EA',
			template: html,
			replace:true,
			transclude: true,
			scope: {
				filterName: '@',
				filterValue: '=',
				filterId: '@',
				filterList: '='
			},
			link: function(scope, element, attrs) {
				scope.readOnly = scope.$parent.filterFunctions.isReadOnly();
				if (!scope.filterValue || scope.filterValue.length == 0) {
					scope.demandSimulations = [getNewDemand()];
				} else {
					var demands = JSON.parse(scope.filterValue);
					angular.forEach(demands, function(demand) {
						demand.date = new Date(demand.date);
					});
					scope.demandSimulations = demands;
				}
				scope.openDemandDatePicker = function(demand) {
					demand.forecastDatePickerOpen = true;
				};

				scope.addDemandRow = function () {
					scope.demandSimulations.push(getNewDemand());
				};

				scope.removeDemandRow = function(index) {
					scope.demandSimulations.splice(index, 1);
				};

				scope.resetDemandSimulations = function($event) {
					try {
						scope.demandSimulations = [getNewDemand()];
						
						$rootScope.$emit('toast', {
							message: 'Simulations cleared',
							type: 'success'
						});
						
					} catch (error) {
						$rootScope.$emit('toast', {
							message: 'Could not reset simulations. Try again.',
							type: 'error'
						});
					}
				};

				scope.hasUserInput = function() {
					if (!scope.demandSimulations || scope.demandSimulations.length === 0) {
						return false;
					}
					return scope.demandSimulations.some(function(demand) {
						return demand.itemNdx || (demand.quantity && demand.quantity > 0) || (demand.date && demand.date instanceof Date);
					});
				};

				scope.trimZeroes = function(s) {
					return s ? s.replace(/^0+/, '') : '';
				};

				scope.applyDemandSelection = function($event) {
					scope.filterValue = JSON.stringify(
						_.chain(scope.demandSimulations)
						.map(function(a) {
							return {'date': a.date, 'quantity': a.quantity, 'itemNdx': a.itemNdx};
						})
						.filter(function(a) {
							return a && a.date && a.quantity >= 0 && a.itemNdx;
						})
					);
					$timeout(function () {
						scope.$parent.filterFunctions.applySelection($event, scope.filterId);
					}, 0);
				};

				scope.filterEndItems = function (searchTerm, demand) {
					if (searchTerm === '' || searchTerm.length <=2 ) {
						if (searchTerm === '' && demand && demand.itemNdx) {
							if (demand.list) {
								return demand.list;
							} else {
								var endItemList = _.filter(scope.filterList, ['endItemNdx', demand.itemNdx]);
								demand.list = endItemList;
								return demand.list;
							}
						} else {
							return [];
						}
					} else {
						var filteredResults = [], i;
						var partialResults = [];
						var regExp = new RegExp('^' + searchTerm.toLowerCase(), 'g');
						for (i = 0; i < scope.filterList.length && filteredResults.length < 20; i++) {
							if (regExp.test(scope.filterList[i].endItemCode.toLowerCase())) {
								filteredResults.push(scope.filterList[i]);
							} else if (scope.filterList[i].endItemCode.toLowerCase().indexOf(searchTerm.toLowerCase()) >= 0) { 
								partialResults.push(scope.filterList[i]);
							}
						}

						if (filteredResults.length < 20) {
							var maxPartialSize = 20 - filteredResults.length;
							maxPartialSize = maxPartialSize > partialResults.length ? partialResults.length : maxPartialSize;
							filteredResults = _.union(filteredResults, partialResults.slice(0, maxPartialSize));
						}
						
						demand.list = filteredResults;
						return filteredResults;
					}
				};

				function getNewDemand() {
					return {
						'date': new Date(),
						'quantity': 0,
						'itemNdx': null
					};
				}
			}
		};
	}
})();
